import isEqual from 'lodash/isEqual';
import checkAdvancedFiltersQuantity from './checkAdvancedFiltersQuantity';
import { initialFieldsValuesForMobileFilters } from '../constants';

const checkFiltersQuantity = (values, routeData) => {
  const advancedFilters = (values.advancedFilters && Object.keys(values.advancedFilters).length)
    ? values.advancedFilters
    : routeData.params;

  const commodities = advancedFilters.commodities;
  const filteredCommodities = (values.optionType === 'buy' && commodities) ?
    commodities.filter(item => item !== 'roommates') :
    commodities;

  if (filteredCommodities) {
    advancedFilters.commodities = filteredCommodities;
  }

  const advanced = checkAdvancedFiltersQuantity(advancedFilters);
  const existedPrice = values.minPrice || values.maxPrice;
  const primary = Object.keys(initialFieldsValuesForMobileFilters)
    .filter(elem => elem !== 'minPrice' && elem !== 'maxPrice')
    .reduce((acc, item) => {
      const currentValue = values[item];
      const initialValue = initialFieldsValuesForMobileFilters[item];
      if (!!currentValue && !isEqual(currentValue, initialValue)) {
        acc += 1;
      }
      return acc;
    }, 0);
  const price = existedPrice ? 1 : 0;
  return (+advanced + primary + price);
};

export default checkFiltersQuantity;
